export const plans = {
  title: "Elige tu plan",
  subtitle: "Precio por unidad y mes, con descuentos por volumen. Puedes combinar varios tipos de alojamiento en un mismo pedido.",
  typeLabel: "Tipo de alojamiento",
  types: {
    apartamento: "Apartamentos",
    hotel: "Hotel",
    camping: "Camping",
    villa: "Villas",
  },
  units: {
    apartamento: "apartamento | apartamentos",
    hotel: "habitación | habitaciones",
    camping: "alojamiento | alojamientos",
    villa: "villa | villas",
  },
  decrease: "Quitar una unidad",
  increase: "Añadir una unidad",
  billing: {
    label: "Facturación",
    monthly: "Mensual",
    annual: "Anual",
    annualSave: "−20%",
  },
  perUnit: "/mes por unidad",
  totalLine: "{qty} {units} · {total}/mes en total",
  billedAnnually: "facturado anual",
  add: "Añadir al pedido",
  isNew: "Nuevo",
  pro: {
    badge: "Más popular",
    tagline: "Toda la plataforma: IA, canales, cobros e ingresos.",
    f1: "Check-in online y parte de viajeros automático a las autoridades",
    f2: "Recepción IA 24/7 por WhatsApp: atiende, resuelve dudas y automatiza",
    f3: "Bandeja unificada (WhatsApp + Booking, Airbnb y Expedia), traducción y escalado a humano",
    f4: "Facturación electrónica VeriFactu",
    f5: "Channel Manager +100 OTAs, calendario unificado y gestión de precios (cero overbooking)",
    f6: "Reservas directas con tu propia web, sin comisiones",
    f7: "Cerraduras inteligentes con códigos de acceso automáticos",
    f8: "Extras y upselling, ampliar estancia y promociones",
    f9: "Cobros y pagos con adelantos",
    f10: "Limpieza y equipo, con roles y accesos",
    f11: "Multipropiedad, analytics e informes por propietario",
  },
  suite: {
    badge: "Todo incluido",
    tagline: "El plan más completo: recepción telefónica con IA, tu propia web y precios dinámicos.",
    lead: "Todo lo del Pro, y además:",
    s1: "Número propio para WhatsApp y llamadas",
    s2: "Recepción IA Telefónica: contesta el teléfono 24/7 en el idioma del huésped",
    s3: "Llamadas entrantes: 40 min/mes incluidos",
    s4: "WebBuilder: tu página web completa",
    s5: "Precios dinámicos: ajuste automático de tarifas",
    s6: "Múltiples entidades de facturación para asociar con cada alojamiento",
  },
  cart: {
    title: "Tu pedido",
    empty: "Elige el tipo de alojamiento y las unidades, y añade un plan.",
    plan: "Plan {plan}",
    remove: "Quitar",
    monthlyTotal: "Total al mes",
    annualTotal: "Facturado al año: {total}",
    planSwitched: "Un pedido lleva un solo plan: ahora todo es {plan}.",
    welcomeTitle: "Descuento de invitación aplicado",
    welcomeMonthly: "{percent}% de descuento los {months} primeros meses: {total}/mes",
    welcomeAnnual: "Ahorras {amount} en tu primera factura anual",
    pay: "Continuar al pago",
    paying: "Abriendo el pago…",
    taxes: "Impuestos no incluidos. Stripe te pedirá los datos de facturación.",
    error: "No hemos podido abrir el pago. Inténtalo de nuevo.",
  },
  payment: {
    success: "Pago recibido. Tu plan se activa en unos segundos.",
    failed: "El pago no se completó. Puedes volver a intentarlo cuando quieras.",
    active: "¡Listo! Tu plan ya está activo.",
  },
  active: {
    includes: "Qué incluye tu plan",
    discount: "Descuento de invitación: {percent}% hasta el {date}",
    discountAnnual: "Descuento de invitación aplicado en tu primera factura",
    referralCredit: "Tienes {amount} de crédito por invitar a otros anfitriones: se descontará de tu próxima factura.",
  },
};
